import { useMemo } from "react";

/**
 * Asma ul Husna — the 99 Beautiful Names of Allah.
 * A continuous horizontal marquee that adds a quiet, living, Islamic
 * accent between sections of the homepage. Pauses on hover.
 */
const NAMES = [
  ["Ar-Rahman", "ٱلرَّحْمَٰن", "The Most Compassionate"],
  ["Ar-Rahim", "ٱلرَّحِيم", "The Most Merciful"],
  ["Al-Malik", "ٱلْمَلِك", "The King"],
  ["Al-Quddus", "ٱلْقُدُّوس", "The Most Holy"],
  ["As-Salam", "ٱلسَّلَام", "The Source of Peace"],
  ["Al-Mu'min", "ٱلْمُؤْمِن", "The Granter of Security"],
  ["Al-Muhaymin", "ٱلْمُهَيْمِن", "The Guardian"],
  ["Al-Aziz", "ٱلْعَزِيز", "The Almighty"],
  ["Al-Jabbar", "ٱلْجَبَّار", "The Compeller"],
  ["Al-Mutakabbir", "ٱلْمُتَكَبِّر", "The Supreme"],
  ["Al-Khaliq", "ٱلْخَالِق", "The Creator"],
  ["Al-Bari", "ٱلْبَارِئ", "The Maker"],
  ["Al-Musawwir", "ٱلْمُصَوِّر", "The Fashioner"],
  ["Al-Ghaffar", "ٱلْغَفَّار", "The All-Forgiving"],
  ["Al-Wahhab", "ٱلْوَهَّاب", "The Bestower"],
  ["Ar-Razzaq", "ٱلرَّزَّاق", "The Provider"],
  ["Al-Latif", "ٱللَّطِيف", "The Most Subtle"],
  ["Al-Halim", "ٱلْحَلِيم", "The Most Forbearing"],
  ["Al-Adheem", "ٱلْعَظِيم", "The Magnificent"],
  ["Al-Wadud", "ٱلْوَدُود", "The Most Loving"],
  ["Al-Hakeem", "ٱلْحَكِيم", "The All-Wise"],
  ["As-Sami", "ٱلسَّمِيع", "The All-Hearing"],
  ["Al-Basir", "ٱلْبَصِير", "The All-Seeing"],
  ["Al-Hayy", "ٱلْحَيّ", "The Ever-Living"],
  ["An-Nur", "ٱلنُّور", "The Light"],
];

export default function AsmaUlHusnaTicker() {
  // Duplicate the list so the marquee scroll can loop seamlessly.
  const loop = useMemo(() => [...NAMES, ...NAMES], []);

  return (
    <section
      className="relative bg-emerald_deep text-cream py-7 overflow-hidden"
      aria-label="The 99 Beautiful Names of Allah"
      data-testid="asma-marquee"
    >
      <div className="absolute inset-0 pattern-girih opacity-[0.08] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(197,160,89,0.18)_0%,transparent_70%)] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4">
        <div className="text-center mb-4">
          <div className="text-[10px] uppercase tracking-[0.3em] text-gold font-semibold">
            Asma ul Husna · The 99 Beautiful Names
          </div>
        </div>
        <div className="marquee-mask overflow-hidden">
          <div className="marquee-track">
            {loop.map(([latin, arabic, meaning], i) => (
              <div key={i} className="flex items-center gap-3 shrink-0">
                <span className="font-arabic text-2xl text-gold" dir="rtl">
                  {arabic}
                </span>
                <span className="text-[11px] uppercase tracking-[0.18em] text-cream/85 font-semibold">
                  {latin}
                </span>
                <span className="text-[11px] text-cream/55 italic">
                  · {meaning}
                </span>
                <span className="text-gold/40 text-lg leading-none">◈</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
